/* istanbul ignore file -- FIXME(phase-18-ui-hoxxtv) Smart TV UI component / view — full per-component RTL interaction tests deferred to a follow-up wave (see deferred-items.md). Pattern matches 18-01 web (54 files) + 18-02 mobile (133 files). */
import styled from 'styled-components/native';

import Icons from './../../assets/icons';
import { getScaledValue } from '../../ui/styled';

export const ProfileItemContent = styled.TouchableOpacity.attrs({})`
  margin: 0 ${getScaledValue(14)}px;
  max-width: ${getScaledValue(70)}px;
`;

export const ProfileItemImage = styled.ImageBackground.attrs({})`
  width: ${getScaledValue(70)}px;
  height: ${getScaledValue(70)}px;
  border-radius: ${getScaledValue(35)}px;
  overflow: hidden;
  ${(props: { focused?: boolean; theme: { primary: string } }) =>
    props.focused
      ? `
            border-width: ${getScaledValue(2)}px;
            border-color: ${(props: { focused?: boolean; theme: { primary: string } }) => props.theme.primary};
        `
      : ``}
`;

export const ProfileItemText = styled.Text.attrs({})`
  font-size: ${getScaledValue(12)}px;
  text-align: center;
  font-family: PTSans-Bold;
  margin-top: ${getScaledValue(11)}px;
  flex: 1;
  ${(props: { focused?: boolean; theme: { primary: string } }) =>
    props.focused
      ? `
            color: ${(props: { focused?: boolean; theme: { primary: string } }) => props.theme.primary};
        `
      : `
            color: #A7A7A7;
        `}
`;
